module.exports = __webpack_public_path__ + "static/media/swooshSound.2dc7f9a4.mp3";